module.exports = __webpack_public_path__ + "img/technology10.a679aade.png";